"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIndexerRewards = exports.GetRewards = exports.GetWithdrawls = exports.IndexerRewardFields = exports.UnclaimedRewardFields = exports.RewardFields = exports.WithdrawalFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.WithdrawalFields = (0, graphql_tag_1.default) `
  fragment WithdrawalFields on Withdrawl {
    id
    index
    delegator
    indexer
    startTime
    amount
    status
    type
  }
`;
exports.RewardFields = (0, graphql_tag_1.default) `
  fragment RewardFields on Reward {
    id
    delegatorAddress
    indexerAddress
    amount
    claimedTime
  }
`;
exports.UnclaimedRewardFields = (0, graphql_tag_1.default) `
  fragment UnclaimedRewardFields on UnclaimedReward {
    id
    delegatorAddress
    indexerAddress
    amount
  }
`;
exports.IndexerRewardFields = (0, graphql_tag_1.default) `
  fragment IndexerRewardFields on IndexerReward {
    id
    indexerId
    eraIdx
    amount
  }
`;
exports.GetWithdrawls = (0, graphql_tag_1.default) `
  query GetWithdrawls($delegator: String!, $status: WithdrawalStatus!, $offset: Int) {
    withdrawls(
      filter: { delegator: { equalTo: $delegator }, status: { equalTo: $status } }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...WithdrawalFields
      }
    }
  }
  ${exports.WithdrawalFields}
`;
exports.GetRewards = (0, graphql_tag_1.default) `
  query GetRewards($address: String!) {
    rewards(orderBy: CLAIMED_TIME_DESC, filter: { delegatorAddress: { equalTo: $address } }) {
      totalCount
      nodes {
        ...RewardFields
      }
    }
    unclaimedRewards(
      filter: { delegatorAddress: { equalTo: $address }, amount: { greaterThan: "0" } }
    ) {
      totalCount
      nodes {
        ...UnclaimedRewardFields
      }
    }
  }
  ${exports.RewardFields}
  ${exports.UnclaimedRewardFields}
`;
exports.GetIndexerRewards = (0, graphql_tag_1.default) `
  query GetIndexerRewards($address: String!, $era1: String!, $era2: String!) {
    indexerRewards(
      filter: {
        indexerId: { equalTo: $address }
        and: { eraIdx: { equalTo: $era1 } }
        or: { eraIdx: { equalTo: $era2 } }
      }
    ) {
      totalCount
      nodes {
        ...IndexerRewardFields
      }
    }
  }
  ${exports.IndexerRewardFields}
`;
//# sourceMappingURL=staking.generated.js.map